import { trackGoogleAnalyticsEvent } from 'common/actions'
import Tracker from 'common/services/Tracker'
import { Product } from 'even-ts-static'
import * as React from 'react'
import { connect } from 'react-redux'
import { RadioButton, RadioButtonTrackingEvent } from 'embed/constants'
import { uiSelectedProductSelector } from 'embed/selectors/ui'

const radioStyles = require('./styles.scss')

export interface RadioButtonProps {
  child: RadioButton
}

export interface InputProps {
  id: string
  name: string
  onChange: (event: React.FormEvent<HTMLInputElement>) => void
  type: string
  value: string
}

interface StoreProps {
  valueFromStore?: string | undefined
}

export interface RadioButtonDispatchProps {
  dispatchTrackTrackingEvent?: (formState: RadioButtonTrackingEvent) => void
}

type Props = InputProps & RadioButtonProps & RadioButtonDispatchProps & StoreProps

const ApplicationFieldRadioButton: React.SFC<Props> = (props) => {
  const { child, valueFromStore } = props
  const { checked, pathToStore, value } = child
  const buttonIsChecked =
    (pathToStore && valueFromStore !== undefined && valueFromStore.toString() === value) || !!checked

  const inputProps = {
    defaultChecked: buttonIsChecked,
    id: props.id,
    name: props.name,
    onChange: (event: React.FormEvent<HTMLInputElement>) => {
      props.onChange(event)
      props.dispatchTrackTrackingEvent?.(props.child.trackingEvent)
    },
    type: props.type,
    value: props.value,
  }
  return (
    <div className={radioStyles.radioButtonContainer}>
      <label className={radioStyles.label} htmlFor={props.child.value}>
        {props.child.label}
      </label>
      <input className={radioStyles.radioButton} {...inputProps} />
    </div>
  )
}

const mapStateToProps = (state, ownProps: RadioButtonProps) => {
  const product = uiSelectedProductSelector(state) ?? ''
  const valueFromStore = ownProps.child.pathToStore && state.filters[product]?.[ownProps.child.pathToStore]
  return {
    valueFromStore,
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatchTrackTrackingEvent: (trackingEvent: RadioButtonTrackingEvent) => {
    dispatch(trackGoogleAnalyticsEvent(trackingEvent.action, undefined, Product.Loan, trackingEvent.data))
    Tracker.trackEvent({
      action: trackingEvent.action.toLowerCase(),
      data: {
        formState: trackingEvent.data,
      },
      timestamp: new Date(),
    })
  },
})
export default connect(mapStateToProps, mapDispatchToProps)(ApplicationFieldRadioButton)
